import { render, staticRenderFns } from "./ProductCategoriesSelect.vue?vue&type=template&id=4c87465e&scoped=true&"
import script from "./ProductCategoriesSelect.vue?vue&type=script&lang=js&"
export * from "./ProductCategoriesSelect.vue?vue&type=script&lang=js&"
import style0 from "./ProductCategoriesSelect.vue?vue&type=style&index=0&id=4c87465e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c87465e",
  null
  
)

export default component.exports